// extracted by mini-css-extract-plugin
export default {"logo":"companyLogo_logo__sJsjc"};